import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';
const LinksMenuList = [
  {
    title: 'Home',
    href: '/',
    onClick: () => window.scrollTo({ top: 0, behavior: 'smooth' })
  },
  {
    title: 'Benefits',
    href: '/#benefits',
    onClick: (e) => {
      e.preventDefault();
      document.getElementById('benefits')?.scrollIntoView({ behavior: 'smooth' });
    }
  },
  {
    title: 'About',
    href: '/#about',
    onClick: (e) => {
      e.preventDefault();
      document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
    }
  },
  {
    title: 'Ingredients',
    href: '/#key-ingredients',
    onClick: (e) => {
      e.preventDefault();
      document.getElementById('key-ingredients')?.scrollIntoView({ behavior: 'smooth' });
    }
  },
  {
    title: 'Comparison',
    href: '/#comparison',
    onClick: (e) => {
      e.preventDefault();
      document.getElementById('comparison')?.scrollIntoView({ behavior: 'smooth' });
    }
  },
  {
    title: 'How to Use',
    href: '/#how-to-use',
    onClick: (e) => {
      e.preventDefault();
      document.getElementById('how-to-use')?.scrollIntoView({ behavior: 'smooth' });
    }
  },
  {
    title: 'Product',
    href: '/#product-section',
    onClick: (e) => {
      e.preventDefault();
      document.getElementById('product-section')?.scrollIntoView({ behavior: 'smooth' });
    }
  },
  {
    title: 'Reviews',
    href: '/#reviews',
    onClick: (e) => {
      e.preventDefault();
      document.getElementById('reviews')?.scrollIntoView({ behavior: 'smooth' });
    }
  },
  {
    title: 'Contact',
    href: '/contact',
  },
];
const policyMenuList = [
  {
    title: 'Terms & Conditions',
    href: '/terms-conditions',
  },
  {
    title: 'Privacy Policy',
    href: '/privacy-policy',
  },
  {
    title: 'Shipping Policy',
    href: '/shipping-policy',
  },
  {
    title: 'Cancellation & Refund',
    href: '/cancellation-refund',
  },
];
export default function Footer() {
  return (
    <footer className="cs_fooer">
      <div className="cs_fooer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="cs_footer_item">
                <div className="cs_text_widget">
                  <img src="/images/ayumedix.png" width={180} alt="Ayumedix Logo" />
                  <div className="cs_height_25"></div>
                  <p>Ayumedix is committed to delivering premium Products for men. Our mission is to empower you with natural products that support daily active lifestyles and overall wellness.</p>
                  
                  <div className="cs_trust_badges">
                    <div className="cs_trust_badge">
                      <Icon icon="mdi:shield-check-outline" fontSize={20} color="#0b5e4b" />
                      <span>GOVT. Certified</span>
                    </div>
                    <div className="cs_trust_badge">
                      <Icon icon="mdi:leaf" fontSize={20} color="#0b5e4b" />
                      <span>Premium Natural</span>
                    </div>
                    <div className="cs_trust_badge">
                      <Icon icon="mdi:truck-delivery-outline" fontSize={20} color="#0b5e4b" />
                      <span>Fast Shipping</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Explore</h2>
                <ul className="cs_menu_widget">
                  {LinksMenuList.map((item, index) => (
                    <li key={index}>
                      <Link to={item.href} onClick={item.onClick}>{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Company</h2>
                <ul className="cs_menu_widget">
                  {policyMenuList.map((item, index) => (
                    <li key={index}>
                      <Link to={item.href}>{item.title}</Link>
                    </li>
                  ))}
                  <li><Link to="/contact">Support</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="cs_footer_item">
                <h2 className="cs_widget_title">Get in Touch</h2>
                <div className="cs_text_widget">
                  <ul className="cs_menu_widget">
                    <li className="d-flex align-items-center gap-2">
                      <Icon icon="mdi:map-marker-outline" color="#0b5e4b" />
                      <span>Gondal, Gujarat, 360311, India</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <Icon icon="mdi:whatsapp" color="#0b5e4b" />
                      <a href="https://wa.me/919313989270" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}}>+91 93139 89270</a>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <Icon icon="mdi:email-outline" color="#0b5e4b" />
                      <span>support@ayumedix.com</span>
                    </li>
                  </ul>
                  <div className="cs_height_20"></div>
                  <p><strong>Support Hours:</strong><br/>Mon-Sat: 9 AM - 8 PM IST</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="cs_footer_disclaimer" style={{ fontSize: '13px', color: '#666', borderTop: '1px solid rgba(0,0,0,0.1)', paddingTop: '15px', marginTop: '15px', textAlign: 'center', marginBottom: '15px' }}>
          <p className="mb-0"><strong>Disclaimer:</strong> This product is not intended to diagnose, treat, cure, or prevent any disease. Results may vary from person to person.</p>
        </div>
        <div className="cs_bottom_footer">
          <div className="cs_copyright">
            &copy; {new Date().getFullYear()} Ayumedix Healthcare. All rights reserved. Managed by Infix Technology<br/>
            <small>Men's Wellness Support</small>
          </div>
          
          <div className="cs_payment_icons">
            <Icon icon="logos:visa" fontSize={30} />
            <Icon icon="logos:mastercard" fontSize={30} />
            <Icon icon="logos:upi" fontSize={30} />
            <Icon icon="mdi:shield-lock" fontSize={24} color="#0b5e4b" />
            <span style={{fontSize: '12px', color: '#666'}}>Secure SSL Encryption</span>
          </div>

          <div className="cs_bottom_footer_right">
            <ul className="cs_footer_links">
              <li><Link to="/privacy-policy">Privacy</Link></li>
              <li><Link to="/terms-conditions">Terms</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
